import * as graphql from 'generated/graphql';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import { UserSelector } from 'packages/kakapo-ui-kit/components/users/UserCollaboratorsSelector';

export type IQueueJoinInput = graphql.User & {
	attendeeType: graphql.LearningEventAttendeeType;
};

export default function LearningEventInviteAttendee(props: {
	event?: graphql.LearningEvent;
	attendeeType: graphql.LearningEventAttendeeType;
	queueJoin?: (input: IQueueJoinInput) => void;
	queuedHosts?: IQueueJoinInput[];
}) {
	const [join, { loading }] = graphql.useJoinLearningEventMutation();

	return loading ? (
		<Spinner isLoading size="18px" />
	) : (
		<UserSelector
			excludeViewer={false}
			selectedUsers={
				props.event ? props.event.hosts.edges.map(({ node }) => node) : props.queuedHosts ?? []
			}
			onSelectUser={(user) => {
				if (!props.event) {
					props.queueJoin?.({ ...user, attendeeType: props.attendeeType });

					return;
				}

				join({
					variables: {
						input: {
							learningEventID: props.event.id,
							userID: user.id!,
							attendeeType: props.attendeeType,
						},
					},
				});
			}}
		/>
	);
}
